/*
 * @Author: your name
 * @Date: 2021-08-11 09:56:03
 * @LastEditTime: 2021-10-14 15:10:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ocr/src/main.js
 */
import {
  createApp
} from 'vue'
import Antd from 'ant-design-vue/es'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import './assets/css/base.css'
import 'tailwindcss/tailwind.css'
import uploader from 'vue-simple-uploader'
import eventBus from 'vue3-eventbus'
import 'xe-utils'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { i18n, lang } from './locales'
import axios from './store/interface'
import dotsConfig from './config/url-config'
import { getItemFromCookie, setItemToCookie } from './utils/url-tools'
VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.global.t(key, args)
})
// 全局语言函数
window.lang = lang
console.log(process.env.VUE_APP_BASE_URL)
//本地环境下，修改从一休化平台跳转的url地址
let dotsUuid
if (process.env.NODE_ENV === 'development') {
  const strs = window.location.href.split('?dots-uuid=')
  if (strs.length > 1) {
    const secHalf = strs[1]
    if (secHalf.includes('#')) {
      dotsUuid = secHalf.split('#')[0]
    }
  }
}
if (dotsUuid) {
  const newUrl = window.location.href.replace(`?dots-uuid=${dotsUuid}`, '') + '?dots-uuid=' + dotsUuid
  window.open(newUrl, '_self')
} else {

  const main = () => {
    const promise1 = process.env.VUE_APP_PRIVATE_CUSTOM === '1'? Promise.resolve(): new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + 'ocr_front_config/server_url_config.json',
      }).then((result) => {
        if (process.env.VUE_APP_CONTAIN_LOGIN === '1') {//本地开发 或 特殊情况打包
          dotsConfig.dotsUrl = '/#'
        } else {
          dotsConfig.dotsUrl = result.data.data.dots_url
        }
        resolve();
      }).finally(() => {
        resolve();
      })

    });
    //用户信息
    const promise2 = new Promise(function (resolve, reject) {
      console.log(22222)
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + 'api/user/info',
      }).then((result) => {
        if (result.data.code == 200) {
          const user = result.data.data.data
          if (user) {
            localStorage.token = getItemFromCookie('dots-token') || localStorage.token
            localStorage.ocrPersonInfo = JSON.stringify(user)
          }
        } else {
          console.log(result)
        }
      }).finally(() => {
        resolve();
      })

    });
    Promise.all([promise1, promise2]).finally(() => {
      const app = createApp(App).use(store).use(router).use(uploader).use(eventBus).use(ElementPlus, { locale: zhCn, })
      app.config.productionTip = false
      app.use(i18n).use(VXETable)
      app.use(Antd).mount('#app')
    })
  }
  let uuid
  const strs = window.location.href.split('?dots-uuid=')
  if (strs.length > 1) {
    uuid = strs[1]
  }
  //
  if (uuid) {
    //先获取token
    const promise = new Promise(function (resolve, reject) {
      console.log(1111111)
      axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + 'manage/auth/dots_login',
        data: { uuid }
      }).then(function (data) {
        // resolve(data.data)
        const result = data.data
        if (result.code == 200) {
          const res = result.data
          if (res) {
            const token = res.token
            setItemToCookie('dots-token', token, null, '/', '', null);
            localStorage.setItem('token', token);
            localStorage.ocrPersonInfo = JSON.stringify(res.info)
          }

        }
        resolve()
      }).catch(err => {
        reject()
      })
    })
    promise.finally(() => {
      main()
    })
    // axios({
    //   method: 'post',
    //   url: process.env.VUE_APP_BASE_URL + 'manage/auth/dots_login',
    //   data: { uuid }
    // }).then(function (data) {
    //   // resolve(data.data)
    //   const result = data.data
    //   if (result.code == 200) {
    //     const res = result.data
    //     if (res) {
    //       const token = res.token
    //       setItemToCookie('dots-token', token, null, '/', '', null);
    //       localStorage.setItem('token', token);
    //       localStorage.ocrPersonInfo = JSON.stringify(res.info)
    //     }

    //   }
    // }).finally(() => {
    //   main()
    // })
  } else {
    main()
  }
}









